export function displayName(_a) {
    var name = _a.name, nickname = _a.nickname, campus = _a.campus;
    return "".concat(name, " - ").concat(nickname, " (").concat(campus, ")");
}
